
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class TransferTimesField extends Vue {
  val = '';

  @Prop()
  readonly!: boolean;

  @Prop()
  value!: any;

  @Prop()
  placeholder!: string;

  @Watch('val')
  watchVal() {
    this.$emit('update', this.val);
  }

  @Watch('value')
  watchValue() {
      this.val = this.value;
  }

  mounted() {
    this.watchValue();
  }
}
